import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchInfoAccountsTypes = getApiActionTypes('FETCH_INFO_ACCOUNTS');
export const createInfoAccountTypes = getApiActionTypes('CREATE_INFO_ACCOUNT');
export const updateInfoAccountTypes = getApiActionTypes('UPDATE_INFO_ACCOUNT');
